// src/icons.ts
import { library } from "@fortawesome/fontawesome-svg-core";

// Import all icons you need throughout your application
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";

// Import regular icons from the free-regular package
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons/faHeart";

// Import social media icons from the brands package
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faTwitch } from "@fortawesome/free-brands-svg-icons/faTwitch";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faReddit } from "@fortawesome/free-brands-svg-icons/faReddit";

// Add all icons to the library
library.add(
    // Regular solid icons
    faBars as any,
    faSearch as any,
    faChevronRight as any,
    faPlay as any,
    faTimes as any,
    faEnvelope as any,
    faHeart as any,

    // Regular (outline) icons
    faHeartRegular as any,

    // Brand icons (fab prefix)
    faYoutube as any,
    faInstagram as any,
    faTwitter as any,
    faFacebook as any,
    faTwitch as any,
    faLinkedin as any,
    faReddit as any
);
